<script setup>
import { ref, useSlots } from 'vue';
import { PhxTabPanel, PhxTabs } from '@phx-styleguides/iwc';
import { get } from 'lodash-es';

const props = defineProps({
  specs: {
    type: Object,
    required: true,
  },
});

const slots = useSlots();

const value = ref('overview');

const onChange = (newValue) => {
  value.value = newValue;
};

const shouldDisplayRow = (row) => {
  if (get(row, 'left') || get(row, 'right')) {
    return true;
  }

  if (get(row, 'slot')) {
    return !!slots[row.slot];
  }

  return false;
};
</script>

<template>
  <phx-tabs
    class="product-spec tabs-group--with-indicator product-page-purchase__product-spec"
    layout="start"
    :indicator-thickness="1"
    :value="value"
    @change="onChange"
  >
    <phx-tab-panel v-for="spec in specs" :id="spec.id" :key="spec.id" :label="spec.label">
      <div class="specs-table">
        <template v-for="(row, i) in spec.values" :key="`${spec.id}-${i}`">
          <div v-if="shouldDisplayRow(row)" class="specs-table__row title-caption">
            <template v-if="row.slot">
              <slot :name="row.slot" />
            </template>
            <template v-else>
              <span class="specs-table__row-left">{{ row.left }}</span>
              <span v-if="row.right" class="specs-table__row-right">{{ row.right }}</span>
            </template>

            <hr class="divider" />
          </div>
        </template>
      </div>
    </phx-tab-panel>
  </phx-tabs>
</template>
